<div class="munily-segmented-control" role="group">
  <button
    *ngFor="let option of options; trackBy: trackOption"
    type="button"
    class="munily-segmented-control__btn"
    [class.is-active]="value === option.value"
    (click)="select(option.value)"
  >
    {{ option.label }}
  </button>
</div>
